import { configureStore } from "@reduxjs/toolkit";
import { todoApiSlice } from "../features/todoApi/todoApiSlice";

export const store = configureStore({
  reducer: {
    [todoApiSlice.reducerPath]: todoApiSlice.reducer,
  },
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(todoApiSlice.middleware),
});
